import { ClippedContent } from 'dyl-components';
import React, { useState } from 'react';
import Avatar from 'react-avatar';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Icon } from 'semantic-ui-react';
import SendEmailModal from 'shared/modals/SendEmailModal';
import NotesModal from 'shared/modals/NotesModal';

import './index.scss';
import { ActivityPopup } from 'shared/forms/NewActivity';
import { PhoneUtil } from 'utils';
import { useLocation, useNavigate } from 'react-router-dom';
import appActions from 'actions/app/app';
import { TextMessageModal } from 'shared/modals';
import { USER_PERMISSIONS } from 'dyl-components';
import RestrictedView from 'shared/RestrictedView';
import TextIcon from 'shared/TextIcon';

const Contact = ({ contact, name, linkToContact, jobTitle, isSimplified, hideId, isModalOutside = false, onExteriorModalOpen, hideContact, account, displayIcon, savedSettingsRoute, isCompact }) => {
    const [modal, setModal] = useState("");

    const dispatch = useDispatch();

    const { pathname } = useLocation();
    const isSettings = pathname?.split?.('/')?.[1] === "settings";
    const navigate = useNavigate();

    const { emailIntegrations, officeViewCreds } = useSelector((state) => {
        return {
            officeViewCreds: state.officeView.creds,
            emailIntegrations: state.oauth_integrations.integrations
        };
    });
    const isPhoneSystemSupported =
        PhoneUtil.isPhoneSystemSupported(officeViewCreds);

    const canEmail = Boolean(contact.email?.id);
    const hasEmailIntegrations = emailIntegrations.length > 0;
    const destination = contact.phone?.find?.((phone) => phone?.main)?.phone
        || contact.phone?.[0]?.value
        || contact?.phone?.phone
        || contact?.phone?.value
    const contact_id = contact.id;
    const account_id = contact.account_id || contact.account?.id || account?.id;
    const [openActivityForm, setOpenActivityForm] = useState('');
    const getModal = () => {
        switch (modal) {
            case "email":
                return <SendEmailModal
                    open={modal === "email"}
                    onClose={() => { setModal("") }}
                    contact_id={contact.id}
                />;
            case "note":
                return <NotesModal
                    open={modal === "note"}
                    onClose={() => { setModal("") }}
                    contact={contact}
                />;
            case "text":
                return <TextMessageModal
                    open={modal === "text"}
                    onClose={() => { setModal("") }}
                    contact_id={contact.id}
                    contact_name={name}
                    isAccount={account}
                    disabled={!destination}
                />;
            default:
                <React.Fragment />
        }
    }

    const onOpenActivityForm = (type) => {
        setOpenActivityForm(type);
    }

    const onCloseActivityForm = () => {
        setOpenActivityForm('');
    }

    return (
        <React.Fragment>
            <Grid columns='equal' verticalAlign='middle'>
                {name && !hideContact && <Grid.Column width={3}><Avatar name={name} maxInitials={2} round size='3em' /></Grid.Column>}
                <Grid.Column width={isCompact ? 13 : 6}>
                    <ClippedContent popupContent={name}>
                        {displayIcon && <Icon className={account === "business" ? "fa-solid fa-building" : account === "household" ? "fa-solid fa-house-chimney-blank" : "user"} />}
                        {linkToContact}
                    </ClippedContent>
                    {(!hideId) && <div>
                        {(jobTitle !== undefined ? jobTitle : `ID: ${contact?.id}`)}
                    </div>}
                </Grid.Column>
                {!isSimplified && (
                    <Grid.Column>
                        <Grid className='Contact__actions' columns='4' verticalAlign='middle'>
                            <Grid.Column>
                                {isPhoneSystemSupported ? <Icon
                                    className='fa-solid fa-phone'
                                    disabled={!destination}
                                    onClick={() => {
                                        if (isSettings) {
                                            navigate(savedSettingsRoute);
                                            dispatch(appActions.onSaveSettingsRoute(""));
                                        }
                                        PhoneUtil.C2D({
                                            payload: {
                                                contact_id: !account ? contact_id : null,
                                                account_id: account_id,
                                                destination
                                            },
                                            dispatch
                                        })
                                    }}
                                    link
                                /> :
                                    <ActivityPopup
                                        trigger={<Icon
                                            className='fa-solid fa-phone'
                                            link
                                            disabled={!destination}
                                        />}
                                        activityProps={{
                                            hideActivitySelection: true,
                                            isContact: true,
                                            contact: { id: account ? null : contact_id },
                                            account: { id: account_id }
                                        }}
                                        open={openActivityForm === 'call'}
                                        onOpen={() => onOpenActivityForm('call')}
                                        onClose={onCloseActivityForm}
                                        disabled={!destination}
                                    />}
                            </Grid.Column>
                            <Grid.Column>
                                <TextIcon 
                                    account_id={account_id}
                                    contact_id={contact_id}
                                    isActivityFormOpen={openActivityForm === 'text'}
                                    onCloseActivityForm={onCloseActivityForm}
                                    onOpenActivityForm={() => {onOpenActivityForm('text')}}
                                    onOpenTextModal={() => {setModal('text')}}
                                    phone={destination}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                {canEmail ?
                                    hasEmailIntegrations ? <Icon className='fa-solid fa-envelope' link onClick={() => {
                                        if (isModalOutside) {
                                            onExteriorModalOpen('email', contact.id);
                                        } else {
                                            setModal("email")
                                        }
                                    }} /> :
                                        <ActivityPopup
                                            trigger={
                                                <Icon className='fas fa-envelope' link />
                                            }
                                            activityProps={{
                                                readTimeline: () => { },
                                                emailOnly: true,
                                                contact: contact,
                                                isContact: true
                                            }}
                                            open={openActivityForm === 'email'}
                                            onOpen={() => setOpenActivityForm('email')}
                                            onClose={() => setOpenActivityForm('')}
                                        />
                                    : <Icon className='fa-solid fa-envelope' link disabled />
                                }
                            </Grid.Column>
                            <Grid.Column>                        
                                <RestrictedView type="disabled" userPermission={USER_PERMISSIONS.CONTACTS_ADD}>
                                    <Icon className='fa-sharp fa-solid fa-pen-clip' link onClick={() => {
                                        if (isModalOutside) {
                                            onExteriorModalOpen('note', contact);
                                        } else {
                                            setModal("note")
                                        }
                                    }} />
                                </RestrictedView>
                            </Grid.Column>
                        </Grid>
                    </Grid.Column>
                )}
            </Grid>
            {!isModalOutside && getModal()}
        </React.Fragment>

    )
}

export default Contact;
